module.exports = __webpack_public_path__ + "7cac9f2cdfb4a923b4291156d3057bea.png";